

var TopControlsActions = function TopControlsActions(Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('TopControlsActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'ToggleWebglMap',
    purpose: 'Trigger the point cloud map',
    payload: ['data']
  });

  Actions.add({
    name: 'ChangeNavigationWhileDisabled',
    purpose: 'Show confirmation popup when user tries to leave edit page via top navigation',
    payload: ['to']
  });

  Actions.add({
    name: 'ContinueWithNavigation',
    purpose: 'Allow user to switch from edit mode to another view while cleaning up edit view',
    payload: []
  });

  Actions.add({
    name: 'ChangeCurrentLayerType',
    purpose: 'Saves the current type of view',
    payload: ['data']
  });

  Actions.add({
    name: 'ToggleMapboxGL',
    purpose: 'Switch between leaflet map and webgl mapbox map renderer',
    payload: ['enabled']
  });

  return Actions;
};

TopControlsActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = TopControlsActions;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/TopControlsActions.js